import * as React from "react";

const styles = require("./stickyBottom.scss");

interface IProps {
  show: boolean;
  children?: any;
  className?: string;
}

const StickyBottom = ({ show, children, className }: IProps) => {
  if (!show) {
    return null;
  } else {
    return (
      <div className={`${styles.stickyWrapper} ${className}`}>{children}</div>
    );
  }
};

export default StickyBottom;
